import Button from "../components/Button";
import { useState } from "react";

export default function useQuantitySelect(
  maxQuantityDefault: number,
  currentQuantity?: number,
  onChange?: (number) => void,
  disableEdits?: boolean
): [any, number, any] {
  const [quantity, setQuantity] = useState(currentQuantity || 1);
  const [maxQuantity, setMaxQuantity] = useState(maxQuantityDefault);

  const canDecrement = !disableEdits && quantity > 1;
  const canIncrement = !disableEdits && quantity < maxQuantity;
  const canPurchase = maxQuantity > 0;

  const selector = (
    <div className="flex flex-row max-w-fit border rounded-lg items-center border-black">
      <Button
        borderClass="border-r"
        roundedClass="rounded-l-lg"
        classes={`${!canDecrement ? "opacity-50" : ""} bg-mint-hover px-4`}
        disabled={!canDecrement}
        onClick={() => {
          if (canDecrement) {
            onChange && onChange(quantity - 1);
            setQuantity(quantity - 1);
          }
        }}
      >
        {canDecrement ? "-" : "·"}
      </Button>
      <span className="px-4">{quantity}</span>
      <Button
        borderClass="border-l"
        roundedClass="rounded-r-lg"
        classes={`${!canIncrement ? "opacity-50" : ""} bg-mint-hover px-4`}
        disabled={!canIncrement}
        onClick={() => {
          if (canIncrement) {
            onChange && onChange(quantity + 1);
            setQuantity(quantity + 1);
          }
        }}
      >
        {canIncrement ? "+" : "·"}
      </Button>
    </div>
  );

  return [selector, quantity, setMaxQuantity];
}
